import React from 'react'
import ReactDOM from 'react-dom'

import { AppInsights } from 'applicationinsights-js';
import { UserManager } from 'oidc-client'
import RouteAuth from './routeAuthClass'
import { register } from './dependencies'
import Repository from './felles/repository'

import { getConfig } from './felles/utils/configUtils';

import '@norkart/bootstrap-override/bootstrap-override.css'
import './index.css'

var authUrl = getConfig('REACT_APP_AUTH_ENDPOINT');
var url = getConfig('REACT_APP_URL');
var appInsightKey = getConfig('REACT_APP_APP_INSIGHT_KEY');

//Account/Login
const publicUrl = url  || 'http://localhost:3000'
const authServer = authUrl

const redirectUri = publicUrl + "/login"
const postLogoutUri = publicUrl+'/'
AppInsights.downloadAndSetup({ instrumentationKey: appInsightKey});
AppInsights.trackEvent('Default index.js event for AI Testing', null, { measurement1: 1 });
AppInsights.trackPageView('Default Index.html', null, { measurement1: 1 }, 10);

register(Repository, new Repository())

register(UserManager, new UserManager({
    authority: authServer,
    client_id: "vautskiftningklient",
    redirect_uri: redirectUri,
    response_type: 'id_token token',
    scope: 'openid profile komtek vautskiftningapi',
    post_logout_redirect_uri : postLogoutUri,
    silent_redirect_uri: postLogoutUri
}))

ReactDOM.render(<RouteAuth />, document.getElementById('root'))




// WEBPACK FOOTER //
// ./src/index.js